module.exports = __webpack_public_path__ + "module.svg?2bf7562e2356b1cee3224887d721372e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/module.svg
// module id = 92
// module chunks = 2